import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { FileText, ExternalLink, Copy } from "lucide-react";
import { toast } from "sonner";

export default function LeadAssessmentTab({ detail, onConvert }) {
  const publicUrl = detail.public_token
    ? `${window.location.origin}/status/${detail.public_token}`
    : null;

  function copyLink() {
    if (!publicUrl) return;
    navigator.clipboard.writeText(publicUrl);
    toast.success("Client status link copied");
  }

  return (
    <div className="mt-4 space-y-4">
      {detail.assessment_id ? (
        <div className="p-4 border border-slate-200 rounded-md bg-[#E6F4F1]">
          <p className="text-sm text-[#0D1B2A] mb-2">This lead has a linked assessment.</p>
          <Link
            to={`/assessment/${detail.assessment_id}`}
            className="text-[#1A7F6E] font-medium text-sm hover:underline"
            data-testid="view-linked-assessment"
          >
            <FileText className="w-4 h-4 inline mr-1" />View assessment report →
          </Link>
        </div>
      ) : (
        <div className="p-6 border border-dashed border-slate-200 rounded-md text-center">
          <p className="text-sm text-slate-500 mb-3">No assessment yet for this lead.</p>
          <Button
            onClick={() => onConvert(detail)}
            className="bg-[#1A7F6E] hover:bg-[#136053] text-white"
            data-testid="convert-to-assessment"
          >
            Convert to assessment
          </Button>
        </div>
      )}

      {publicUrl && (
        <div className="p-4 border border-slate-200 rounded-md space-y-3">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Client status page</p>
            <p className="text-xs text-slate-500 mb-2">
              Share this link so the client can follow their registration journey without logging in.
            </p>
            <div className="flex items-center gap-2">
              <code className="flex-1 truncate text-xs bg-slate-50 border border-slate-200 rounded px-2 py-1.5 text-[#0D1B2A]" data-testid="public-status-link">
                {publicUrl}
              </code>
              <Button size="sm" variant="outline" onClick={copyLink} data-testid="copy-public-link">
                <Copy className="w-3.5 h-3.5 mr-1" />Copy
              </Button>
              <a href={publicUrl} target="_blank" rel="noreferrer"
                className="text-xs text-[#1A7F6E] hover:underline inline-flex items-center gap-1" data-testid="open-public-link">
                Open <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          </div>
          {(detail.client_confirmed_docs || []).length > 0 && (
            <div className="pt-3 border-t border-slate-100" data-testid="client-confirmed-docs">
              <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-1.5">
                Client-confirmed documents · {detail.client_confirmed_docs.length}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {detail.client_confirmed_docs.map((k) => (
                  <span key={k} className="text-[11px] font-medium bg-[#E6F4F1] text-[#1A7F6E] px-2 py-0.5 rounded">
                    {k}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
